/**
 * @fileoverview Zod schemas for /auth/me profile used in Settings.
 * @module features/settings/schemas/meSchemas
 */

import { z } from 'zod'
import { OrgIdSchema, OrgSchema } from '@/features/orgs/schemas/orgSchemas'

/**
 * Schema for /auth/me response with userId and organizations.
 */
export const MeSchema = z
  .object({
    userId: z.string().uuid(),
    email: z.string().email().nullable().optional(),
    preferredLanguage: z.string().min(1).optional(),
    defaultOrgId: OrgIdSchema.optional(),
    organizations: z.array(OrgSchema),
  })
  .passthrough()

export type MeProfile = z.infer<typeof MeSchema>
